export default __webpack_public_path__ + "static/media/isLogo.88bb46c1.png";